'use strict';

import jQuery from 'jquery';
import PostModel from './PostModel';
import Collection from '../../Collection';

var PostCollection = (function ($) {

  // Define a new PostCollection function
  function PostCollection(fetchAction) {

    Collection.call(this, fetchAction);

    // Define the default empty state for the model
    this._state = {
      collection: [],
      updated: 0
    };
  }

  // PostCollection.prototype = new Collection();

  PostCollection.prototype = Object.create(Collection.prototype);

  PostCollection.prototype.constructor = PostCollection;

  /**
   * Fetches posts from the server
   *
   * @returns {jQuery.Promise} A promise that resolves to a fetched collection
   */
  PostCollection.prototype.fetch = function fetch(postOffset, postLimit, category, property, force) {

    // Create a self reference for association during callbacks
    var self = this;

    // If this model has already been fetched and a force is not required, then
    // just return a promise that will resolve with the self reference
    if (this._state.updated !== 0 && (typeof force === 'undefined' || force !== true)) {

      // Simply return a resolved promise
      return $.Deferred().resolve(self).promise();
    }

    // Create a promise to fetch the core data for the post collection
    var contentPromise = $.ajax({
      url: window.themosis.ajaxurl, // Global access to the WordPress ajax handler file
      type: 'GET',
      dataType: 'json',
      data: {
        action: 'PostComponent.getPosts',
        offset: postOffset,
        limit: postLimit,
        category: category,
        property: property
      }
    });

    // Chain the content promise to store an updated time and ultimately provide
    // the self reference on resolution
    return contentPromise.then(function resolveShowPromise(collection) {

      // Store the resulting collection data
      self._state.collection = collection.map(function transformToVideoModel(data) {

        // Create a new model
        var v = new PostModel();

        // Set the data for the post
        v.setContent(data);

        // Return the transformation to the post model
        return v;
      });

      // Return the collection state
      return self._state.collection;
    }).then(function updateFetchTimestamp() {

      // Update the timestamp for the last fetch
      self._state.updated = Date.now();
    }).then(function resolveFetchPromiseChain() {

      // Now that the collection has been stored, return the reference to this
      // collection as the value of the next promise resolution
      return self;
    }).promise();
  };

  return PostCollection;
})(jQuery);

export default PostCollection;